import {AnyAction} from "redux";
import {SET_SCORE, ADD_SCORE, UPDATE_SCORE, SET_SEASON, RESET_SEASON, NEXT_SEASON, TRIGGER_SEASONAL_CONTENT, SET_YEAR, INCREMENT_YEAR, START_YEAR, END_YEAR, TEST_ANNUAL_TARGETS} from "../action";


/**
 * set the season id
 */
export function setSeason(season_id: string) : AnyAction
{
    return {type: SET_SEASON, payload: {season_id}};
}


export function setYear(year: number) : AnyAction
{
    return {type: SET_YEAR, payload: {year}};
    // return {type: SET_YEAR, payload: { year: 5 }};
}


/**
 * set the season id
 */
export function resetYear() : AnyAction
{
    return {type: SET_YEAR, payload: { year: 0 }};
    // return {type: SET_YEAR, payload: { year: 5 }};
}


/**
 * wind on to the next season
 */
export function incrementYear() : AnyAction
{
    return {type: INCREMENT_YEAR, payload: {}};
}


/**
 * start the year
 */
export function startYear() : AnyAction
{
    return {type: START_YEAR, payload: {}};
}


/**
 * complete the year
 */
export function completeYear() : AnyAction
{
    return {type: START_YEAR, payload: {}};
}


/**
 * complete the year early
 */
export function completeYearEarly() : AnyAction
{
    return {type: START_YEAR, payload: {}};
}


/**
 * end the year
 */
export function endYear() : AnyAction
{
    return {type: END_YEAR, payload: {}};
}


/**
 * trigger season-specific content
 */
export function triggerSeasonalContent() : AnyAction
{
    return {type: TRIGGER_SEASONAL_CONTENT, payload: {}};
}



/**
 * test whether the player has met their targets for the year
 */
export function testAnnualTargets() : AnyAction
{
    return {type: TEST_ANNUAL_TARGETS, payload: {}};
}



// WEBPACK FOOTER //
// ./src/ts/store/actions/calendar/year.ts